import { Controller } from '@hotwired/stimulus'
import { listenToChangesOnForm } from 'packs/ui/app/components/ui/_input/_broadcast_change_utils'

export default class extends Controller<HTMLElement> {
  static values = { hideClass: String }
  declare hideClassValue: string
  declare hasHideClassValue: boolean

  private form?: HTMLFormElement

  connect(): void {
    this.form = (this.element.closest('form') as HTMLFormElement | null) || undefined
    if (!this.form) return

    listenToChangesOnForm(this.form, () => this.show(), false)
    this.form.addEventListener('change', () => this.show())
    this.form.addEventListener('input', () => this.show())
    this.form.addEventListener('submit', () => this.hide())
  }

  private show(): void {
    this.element.classList.remove(this.hideClass())
  }
  private hide(): void {
    this.element.classList.add(this.hideClass())
  }
  private hideClass(): string {
    return this.hasHideClassValue ? this.hideClassValue : 'hidden'
  }
}
